import BaseAPI from "../base";

class MenZhenService extends BaseAPI {
  // 体检-套餐列表
  getWorkAddInit(params) {
    return this.post({
      url: "/YuanHe/Menzhen/WorkTijianMealList",
      data: params,
    });
  }

  // 套餐详情
  workDetail(params) {
    return this.post({
      url: "/YuanHe/Menzhen/WorkDetail",
      data: params,
    });
  }

  // 日志详情
  workServiceLogList(params) {
    return this.post({
      url: "/YuanHe/Menzhen/workServiceLogList",
      data: params,
    });
  }

  // 门诊预约排班查询
  bookQuery(params) {
    return this.post({
      url: "/YuanHe/Menzhen/BookQuery",
      data: params,
    });
  }

  // 门诊体检查询挂账公司列表
  bookCompanyList(params) {
    return this.post({
      url: "/YuanHe/Menzhen/BookCompanyList",
      data: params,
    });
  }

  // 是否存在已取消的工单
  workExist(params) {
    return this.post({
      url: "/YuanHe/Menzhen/WorkExist",
      data: params,
    });
  }

  // 工单评论列表
  commentList(params) {
    return this.post({
      url: "/YuanHe/MenZhen/CommentList",
      data: params,
    });
  }

  // 工单评论追加
  commentAppend(params) {
    return this.post({
      url: "/YuanHe/MenZhen/CommentAppend",
      data: params,
    });
  }

  // 消息标记已读
  messageMarkRead(params) {
    return this.post({
      url: "/YuanHe/Book/MessageMarkRead",
      data: params,
    });
  }
}

export default new MenZhenService();
